import React from "react";
import LibrarySong from "./LibrarySong";

const Library = ({
  songs,
  setCurrentSong,
  isPlaying,
  audioRef,
  libraryStatus,
  setLibraryStatus,
  activeSong,
}) => {
  return (
    <div className={`library ${libraryStatus ? "active-library" : ""}`}>
      <h2>PlayList</h2>
      <div className="library-songs">
        {songs.map((song, i) => (
          <LibrarySong
            song={song}
            setCurrentSong={setCurrentSong}
            key={song.id}
            isPlaying={isPlaying}
            audioRef={audioRef}
            setLibraryStatus={setLibraryStatus}
            activeSong={activeSong}
          />
        ))}
      </div>
    </div>
  );
};

export default Library;
